import { render } from "./Footer.vue?vue&type=template&id=50eaa7a0"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=50eaa7a0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__